// Yugiq landing page static content

export const NAV_LINKS = [
  { label: "What we do", href: "#capabilities" },
  { label: "Work", href: "#portfolio" },
  { label: "AI Services", href: "#services" },
  { label: "Insights", href: "#insights" },
  { label: "FINUS", href: "/finus" },
];

export const SERVICES = [
  { icon: "message", name: "AI Chatbot + CRM", metric: "Hindi · EN · MR", tag: "Support" },
  { icon: "phone", name: "AI Voice Human", metric: "3 languages", tag: "Voice" },
  { icon: "send", name: "Outreach Engine", metric: "10× reply rate", tag: "Growth" },
  { icon: "cpu", name: "Lead Scoring AI", metric: "94% accuracy", tag: "Sales" },
  { icon: "pen", name: "Content Studio", metric: "50 posts/wk", tag: "Content" },
  { icon: "search", name: "SEO Engine", metric: "+240% traffic", tag: "SEO" },
  { icon: "target", name: "Meta Ads AI", metric: "-38% CAC", tag: "Ads" },
  { icon: "globe", name: "Website Maker", metric: "Ship in 1 day", tag: "Build" },
  { icon: "smartphone", name: "App Maker", metric: "iOS + Android", tag: "Build" },
  { icon: "map", name: "AI Itinerary Builder", metric: "Instant plans", tag: "Travel" },
  { icon: "calendar", name: "Appointment Maker", metric: "-35% no-show", tag: "Bookings" },
  { icon: "chart", name: "Data & Strategy AI", metric: "We plan for you", tag: "Strategy" },
  { icon: "mail", name: "Email Sequences", metric: "AI-personalised", tag: "Growth" },
  { icon: "briefcase", name: "AI HR Assistant", metric: "Screening → 3 min", tag: "HR" },
  { icon: "coin", name: "Finance Copilot", metric: "Auto-reconcile", tag: "Finance" },
  { icon: "grid", name: "Custom CMS", metric: "No-code", tag: "Ops" },
  { icon: "share", name: "Social Autopilot", metric: "8 channels", tag: "Content" },
  { icon: "shield", name: "AI Review Manager", metric: "Auto-reply", tag: "Reputation" },
  { icon: "sparkle", name: "AI Positioning", metric: "Brand OS", tag: "Strategy" },
  { icon: "cpu", name: "AI Ops Monitor", metric: "3× retain", tag: "Ops" },
  { icon: "languages", name: "Multilingual AI", metric: "HI · EN · MR", tag: "AI Human" },
];

export const INDUSTRIES = [
  {
    key: "real-estate", name: "Real Estate", emoji: "🏗️",
    pain: ["Crore-value leads ghost within 5 min", "Site visits no-show 40%", "Reviews scattered across MB / 99acres"],
    friction: ["Sales exec busy · reply after 2hrs", "No follow-up on cold leads", "Manual project pitching over WhatsApp"],
    solution: ["AI human replies in 8s in HI/EN/MR", "Shares floor plans, price sheets, reviews in chat", "Books site visits + reminder calls"],
    results: [{ v: "21×", l: "Faster reply" }, { v: "2.8×", l: "Site visits" }, { v: "-40%", l: "CPL" }],
  },
  {
    key: "healthcare", name: "Healthcare", emoji: "🩺",
    pain: ["No-shows kill calendar", "After-hours enquiries lost", "Reviews decide 68% of bookings"],
    friction: ["Front desk juggles calls", "Manual reminders skipped", "No system to nudge for reviews"],
    solution: ["AI human books + confirms in patient's language", "Auto WhatsApp / voice reminders", "Prompts happy patients for reviews"],
    results: [{ v: "↑42%", l: "Bookings" }, { v: "-60%", l: "No-shows" }, { v: "3hrs", l: "Saved/day" }],
  },
  {
    key: "retail", name: "Retail & Malls", emoji: "🛍️",
    pain: ["Footfall drops with no clear reason", "Loyalty apps go unused", "Reviews aren't tied to promotions"],
    friction: ["Store staff don't capture buyer data", "SMS campaigns get 2% opens", "No local SEO strategy"],
    solution: ["AI human handles catalog Qs in 3 languages", "WhatsApp offers + review nudges auto-sent", "Data & Strategy AI recommends store-level plays"],
    results: [{ v: "↑30%", l: "Repeat" }, { v: "4×", l: "Reviews" }, { v: "+40%", l: "Social reach" }],
  },
  {
    key: "finance", name: "Financial Services", emoji: "🏦",
    pain: ["Cold leads pile up in CRM", "KYC drop-offs mid-form", "Recovery calls skipped"],
    friction: ["No language matching for regional clients", "Compliance calls take hours", "No dashboard for ROI"],
    solution: ["AI voice human in HI/EN/MR for KYC + recovery", "Auto-scoring qualifies leads instantly", "Live compliance-safe scripts"],
    results: [{ v: "40%", l: "Recovery" }, { v: "-50%", l: "Cost" }, { v: "94%", l: "Score accuracy" }],
  },
  {
    key: "education", name: "Education & Coaching", emoji: "🎓",
    pain: ["Enquiries flood at 10pm — go cold", "Batch info sent manually", "Alumni CRM = a spreadsheet"],
    friction: ["Counselors overwhelmed peak season", "No personalized nurture", "Zero visibility into intent"],
    solution: ["AI human answers in student's language 24/7", "Auto-shares fee sheet, reviews, batch dates", "Nurtures until enrolled + alumni loop"],
    results: [{ v: "↑35%", l: "Enrollment" }, { v: "24/7", l: "Response" }, { v: "3×", l: "Nurture rate" }],
  },
  {
    key: "restaurants", name: "Restaurants & Food", emoji: "🍽️",
    pain: ["Reservations lost to Zomato", "Reviews own you, not the other way", "Repeat orders hard to build"],
    friction: ["No direct WhatsApp channel", "Local SEO invisible", "Menu changes need dev"],
    solution: ["AI human takes reservations in HI/EN/MR", "Review AI replies fast, nudges 5-star fans", "SEO Engine puts you at #1 for 'best <cuisine> <city>'"],
    results: [{ v: "#1", l: "Google" }, { v: "87", l: "Reviews / 90d" }, { v: "↑55%", l: "Direct book" }],
  },
  {
    key: "auto", name: "Automobile Dealers", emoji: "🚗",
    pain: ["Test drives don't get booked in time", "Service reminders forgotten", "Cross-sell insurance dies in email"],
    friction: ["Sales team focuses on walk-ins only", "No language match for local buyers", "Manual follow-ups after 3 days"],
    solution: ["AI voice human calls in Marathi/Hindi", "Books test drives + auto service SMS", "Shares car specs, EMI, reviews in chat"],
    results: [{ v: "↑38%", l: "Test drives" }, { v: "-25%", l: "Drop-off" }, { v: "24/7", l: "Follow-up" }],
  },
  {
    key: "hotels", name: "Hotels & Travel", emoji: "🏝️",
    pain: ["Direct bookings lose to OTAs (30% cut)", "Group enquiries take 2 days", "Concierge asks repeat every check-in"],
    friction: ["No 24×7 booking desk", "Itineraries hand-crafted per lead", "Reviews scattered across TripAdvisor / MMT"],
    solution: ["AI human quotes + books directly on WA in 3 languages", "AI Itinerary Builder generates day-plans instantly", "Concierge remembers prefs across stays"],
    results: [{ v: "3×", l: "Direct leads" }, { v: "12s", l: "Quote reply" }, { v: "-30%", l: "OTA fees" }],
  },
];

export const TESTIMONIALS = [
  {
    quote: "Yugiq replaced three tools and a mid-sized ops team. We ship in a week what took a quarter.",
    name: "Aarav Mehta",
    role: "Founder, Hexa Realty",
  },
  {
    quote: "The voice agent alone books ~200 test drives a week. It doesn't sleep, doesn't forget.",
    name: "Priya Shah",
    role: "GM, Vroom Autos",
  },
  {
    quote: "Not another chatbot. It's the ops layer we didn't know we needed.",
    name: "Dr. Ishaan Rao",
    role: "Director, Aura Clinics",
  },
];

export const INDUSTRY_OPTIONS = INDUSTRIES.map(i => i.name);
